import {KpiUpdate} from '@domain/expert-system'
import {useState} from 'react'
import {z} from 'zod'

import {AssignedUser, Item} from '../types'

export const formSchema = z.object({
  responsibleUserIds: z.array(z.string().min(1)),
  kpiNodes: z.array(
    z.object({
      id: z.string().uuid().optional(),
      name: z.string().min(3),
      kpiAssignmentId: z.number().optional(),
      label: z.string().optional(),
      millType: z.string().optional(),
      expertSystemName: z.string().optional()
    })
  )
})

export type FormData = z.infer<typeof formSchema>

export type FieldErrors = {
  responsibleUserIds?: Record<string, string>
  kpiNodes?: Record<string, string>
}

export const getFieldErrors = (
  error: z.ZodError,
  items: Array<{id?: string}>,
  users: Array<{id?: string}>
): FieldErrors => {
  const fieldErrors: FieldErrors = {}

  error.errors.forEach((err) => {
    const path = err.path

    if (path[0] === 'responsibleUserIds') {
      if (typeof path[1] === 'number') {
        const index = path[1]
        const userId = users[index]?.id || `temp-user-${index}`

        if (!fieldErrors.responsibleUserIds) {
          fieldErrors.responsibleUserIds = {}
        }
        fieldErrors.responsibleUserIds[userId] = err.message
      } else {
        if (!fieldErrors.responsibleUserIds) {
          fieldErrors.responsibleUserIds = {}
        }
      }
    }

    if (path[0] === 'kpiNodes') {
      if (typeof path[1] === 'number') {
        const index = path[1]

        const itemId = items[index]?.id || `temp-${index}`

        if (!fieldErrors.kpiNodes) {
          fieldErrors.kpiNodes = {}
        }
        if (!fieldErrors.kpiNodes) {
          fieldErrors.kpiNodes = {}
        }
        fieldErrors.kpiNodes[itemId] = err.message
      } else {
        if (!fieldErrors.kpiNodes) {
          fieldErrors.kpiNodes = {}
        }
        fieldErrors.kpiNodes['_general'] = err.message
      }
    }
  })

  return fieldErrors
}

export function useResponsibleUsersValidation() {
  const [isDirty, setIsDirty] = useState<boolean>(false)
  function validateEntries(
    data: KpiUpdate,
    users: AssignedUser[],
    items: Item[]
  ): {success: boolean; errors: FieldErrors} {
    const result = formSchema.safeParse(data)
    return {
      success: result.success,
      errors: !result.success ? getFieldErrors(result.error, items, users) : {}
    }
  }
  return {validateEntries, isDirty, setIsDirty}
}
